module.exports = __webpack_public_path__ + "img/signout.25927a47.png";